import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Image from "next/image";
import CustomButton from "@/components/common-components/CustomButton";
import CustomModal from "@/components/common-components/CustomModal";

export default function AboutSubCategories({
  categoryDetails,
  marketArea,
}) {
  const descriptionContent = (
    (marketArea?.is_default
      ? categoryDetails?.category_description
      : categoryDetails?.default_category_description) || ""
  ).replace(/"target_region"/g, marketArea?.name);

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 6000);

  }, [])

  return (
    <>
      <section className=" about-content">
        <Container>
          <div className="grid about-category-content">
            <div
              className="text-center overflow-hidden img-content g-col-12 g-col-md-6 g-col-lg-5"
              data-aos="fade-right"
            >
              <Image
                src={categoryDetails?.category_image || ""}
                className="object-fit-cover"
                width={548}
                height={548}
                alt={`${categoryDetails?.image_alt}-in-${marketArea?.name}`}
                title={`${categoryDetails?.image_alt} in ${marketArea?.name}`}
                onClick={handleShow}
              />
            </div>
            <div data-aos="fade-left" className="g-col-12 g-col-md-6 g-col-lg-7">
              <h2 className="fw-semibold text-capitalize">
                {categoryDetails?.page_sub_title} {`in ${marketArea?.name}`}
              </h2>

              <div
                className="html-content mt-3"
                dangerouslySetInnerHTML={{
                  __html: descriptionContent,
                }}
              />
              <div className="mt-2 mt-md-3 mt-lg-4  d-flex gap-4">
                <CustomButton
                  text="Get a Quote"
                  onClick={handleShow}
                />
                {categoryDetails?.brochure_file && (
                  <CustomButton
                    text="View Brochure"
                    target="_blank"
                    href={`${categoryDetails?.brochure_file || ""}`}
                  />
                )}
              </div>
            </div>
          </div>
        </Container>
      </section>

      <CustomModal
        show={show}
        onHide={() => setShow(false)}
        categoryDetails={categoryDetails}
        image={categoryDetails?.category_image || ""}
        alt={`${categoryDetails?.image_alt}-in-${marketArea?.name}`}
        title={`${categoryDetails?.image_alt} in ${marketArea?.name}`}
      />

    </>
  );
}
